/**
 * Created by shubham on 20/11/18.
 */

import { NgModule} from '@angular/core';
import { Http} from '@angular/http';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { RequestBusinessUnitRoutingModule } from './request-business-unit-routing.module';
import { RequestBusinessUnitComponent } from './request-business-unit.component';
import { AddBusinessUnitForUserComponent } from './add-business-unit/add-business-unit.component';
import { BusinessUnitListForUserComponent } from './business-unit-list/business-unit-list.component';
import { ViewBusinessUnitForUserComponent } from './view-business-unit/view-business-unit.component';
import { TranslateModule,TranslateLoader,TranslateStaticLoader } from 'ng2-translate';
import { APPCONFIG } from '../../config';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        NgxDatatableModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMultiSelectModule,
        RequestBusinessUnitRoutingModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            useFactory: (http: Http) => new TranslateStaticLoader(http, APPCONFIG.URL+'/_ah/api/noAuthApi/v1/i18nJson', ''),
            deps: [Http]
        })
    ],
    declarations: [
        RequestBusinessUnitComponent,
        AddBusinessUnitForUserComponent,
        BusinessUnitListForUserComponent,
        ViewBusinessUnitForUserComponent
    ],
    exports: [

    ]
})

export class RequestBusinessUnitModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-operations/request-business-unit/request-business-unit.module.ts